import { render, staticRenderFns } from "./patients.vue?vue&type=template&id=1e8c1dd8&scoped=true"
import script from "./patients.vue?vue&type=script&lang=js"
export * from "./patients.vue?vue&type=script&lang=js"
import style0 from "./patients.vue?vue&type=style&index=0&id=1e8c1dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8c1dd8",
  null
  
)

export default component.exports